import { useAuth } from '@/features/auth/authContext'

/**
 * The studio's IANA zone, for turning a form's wall clock into the instant the
 * backend wants. It comes from the session rather than the browser: two
 * locations in different countries do not share a clock.
 */
export function useStudioTimezone(): string {
  const { location } = useAuth()
  return location?.timezone ?? Intl.DateTimeFormat().resolvedOptions().timeZone
}
